// When the user scrolls the page, execute myFunction
window.onscroll = function() {navScrollFixed()};

// Get the header
var header = document.getElementById("navBrand");

// Get the offset position of the navbar
var fixed = header.offsetTop;

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function navScrollFixed() {
  if (window.pageYOffset > fixed) {
    header.classList.add("fixed");
  } else {
    header.classList.remove("fixed");
  }
}

[].forEach.call(document.querySelectorAll('.menu-item'), function(el) {
  el.addEventListener('click', function() {
    let menuActive = document.querySelector('.menu-item.active');
    if(typeof menuActive !== "undefined" && menuActive !== null){
          menuActive.classList.remove("active");
    }

    el.classList.add('active');
    var currentClass = el.getAttribute("data-class");
    currentClass = '.' + currentClass;
    console.log(currentClass)
    var topCurrentClass = document.querySelector(currentClass).offsetTop;
    window.scrollTo({
        top : topCurrentClass,
        left : 0,
        behavior : "smooth"
    });

  })
});